import React,{useState} from 'react'
import styles from "./style.module.css"
import TopNavbar from '../navbar/TopNavbar';
import Footer from '../footer/Footer'
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

// Set worker path
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export default function KnowledgeHub() {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <>
    <TopNavbar/>
    <br></br> <br></br> <br></br><br></br><br></br>
    <div style={{ width: '80%', margin: 'auto' }}>
      <Document
        file="/Right.pdf"
        onLoadSuccess={onDocumentLoadSuccess}
      >
        <Page pageNumber={pageNumber} />
      </Document>
      <p>
        Page {pageNumber} of {numPages}
      </p>
    </div>
   
    <Footer/>
    </>
  )
}
